import type { StackProps } from '@mui/joy';

import type { AskAQuestionVariant, VariantStyle } from './types';

export const DEFAULT_TITLE = 'Have questions?';
export const DEFAULT_SUBTITLE = 'Get answers from our experts.';
export const DEFAULT_CTA_LABEL = 'Ask a question';

export const DEFAULT_TEXT = {
  direction: 'column' as StackProps['direction'],
  alignItems: 'flex-start' as StackProps['alignItems'],
  innerGap: 0 as StackProps['gap'],
};

export const VARIANTS: Record<AskAQuestionVariant, VariantStyle> = {
  // Figma 172:3806 / 172:3827 — no icon, stacked title+subtitle, solid-green CTA.
  default: {
    container: { variant: 'outlined', padding: 2 },
    outerGap: 2,
    icon: { show: false, size: 32 },
    text: DEFAULT_TEXT,
    title: { level: 'title-md' },
    subtitle: { fontSize: 'xs', fontWeight: 'md', noWrap: false },
    button: { variant: 'solid', color: 'primary' },
  },
  // Figma 7:12886 — icon + inline title/subtitle; 14px subtitle + noWrap; solid CTA.
  compact: {
    container: { variant: 'outlined', padding: 2 },
    outerGap: 1,
    icon: { show: true, size: 32 },
    text: {
      direction: 'row',
      alignItems: 'baseline',
      innerGap: 1,
    },
    title: { level: 'title-md' },
    subtitle: { fontSize: 'sm', fontWeight: 'md', noWrap: true },
    button: { variant: 'solid', color: 'primary' },
  },
  // Figma 174:2228 / 174:2242 / 174:2256 — no icon, stacked title+subtitle, outlined CTA.
  outlined: {
    container: { variant: 'outlined', padding: 2 },
    outerGap: 2,
    icon: { show: false, size: 32 },
    text: DEFAULT_TEXT,
    title: { level: 'title-md' },
    subtitle: { fontSize: 'xs', fontWeight: 'md', noWrap: false },
    button: { variant: 'secondary' },
  },
  // Figma 11:12932 — borderless/padding-less (sits inside an outer banner);
  // 52px icon, h4 title, 14px semibold subtitle, solid CTA.
  hero: {
    container: { variant: 'plain', padding: 0 },
    outerGap: 2,
    icon: { show: true, size: 52 },
    text: DEFAULT_TEXT,
    title: { level: 'h4' },
    subtitle: { fontSize: 'sm', fontWeight: 'lg', noWrap: true },
    button: { variant: 'solid', color: 'primary' },
  },
};
